import { render, staticRenderFns } from "./BusinessCompletion.vue?vue&type=template&id=9f61ff1c&"
import script from "./BusinessCompletion.vue?vue&type=script&lang=js&"
export * from "./BusinessCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports